export default __webpack_public_path__ + "static/media/whyBrokerIcon2.5302ff3f.webp";